import { PortalError } from '../error/portal-error';

export type TxErrorCode = 'MISSING_DATA' | 'MISSING_ROUTE';

export class TxError extends PortalError<TxErrorCode> {}
